<template>
  <BaseTable
      :title="$t('group')"
      :subtractHeight="subtractHeight"
      :height="height"
      dto-model="GroupListQueryDTO"
      :dto-save-list-model="null"
      store-name="GroupTable"
      :new-item-component="null"
      :new-item-pass="null"
      :lang-dictionary="function(text) {return $t(text)}"
      fixed-header
  >
    <template v-slot:top.right="instance"><span></span></template>
  </BaseTable>
</template>

<script>

import BaseTable from "@/components/Base/BaseTable";
import BaseDeleteIcon from "@/components/Base/BaseDeleteIcon";

export default {
  name: 'GroupTable',
  props: {
    subtractHeight: {type: [Number], default: 140},
    height: {type: [Number], default: window.innerHeight},
    modalDialog: {type: [Boolean], default: false}
  },

  components: {
    BaseTable,
    BaseDeleteIcon,
  },

  computed: {},

  methods: {},

  async mounted() {
    // console.log('mounted')
  },

  created() {
  },

  destroyed() {
  },

  beforeCreate() {
  },

  beforeDestroy() {
  },

  data() {
    return {}
  }
}
</script>

<style>
.row_even {
}
</style>

<i18n>
{
  "en": {
    "group": "Group",
    "columns": {
      "name": "Name"
    }
  },
  "de": {
    "group": "Gruppe",
    "columns": {
      "name": "Name"
    }
  }
}
</i18n>
